import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

const FRAMES = [
  { src: "/brand/boutique-walk.jpg", pos: "center center" },
];

export default function HeroFilm() {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((v) => (v + 1) % FRAMES.length), 5000);
    return () => clearInterval(t);
  }, []);
  return (
    <div data-testid="hero-film" className="absolute inset-0 overflow-hidden bg-obsidian">
      <AnimatePresence>
        <motion.img
          key={i}
          src={FRAMES[i].src}
          alt=""
          aria-hidden="true"
          initial={{ opacity: 0, scale: 1 }}
          animate={{ opacity: 1, scale: [1, 1.09, 1] }}
          exit={{ opacity: 0 }}
          transition={{ opacity: { duration: 1.6, ease: "easeInOut" }, scale: { duration: 28, ease: "easeInOut", repeat: Infinity } }}
          style={{ objectPosition: FRAMES[i].pos }}
          className="absolute inset-0 h-full w-full object-cover"
        />
      </AnimatePresence>
    </div>
  );
}
